import { render, staticRenderFns } from "./InfomationTemplate.vue?vue&type=template&id=94caa8b8&scoped=true&"
import script from "./InfomationTemplate.vue?vue&type=script&lang=js&"
export * from "./InfomationTemplate.vue?vue&type=script&lang=js&"
import style0 from "./InfomationTemplate.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./InfomationTemplate.vue?vue&type=style&index=1&id=94caa8b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94caa8b8",
  null
  
)

export default component.exports